<ng-container *ngIf="!translateParams.sanitize">{{ translated }}</ng-container>
<span
  *ngIf="translateParams.sanitize"
  [innerHTML]="translated | safeHtml"></span>
